import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["attributesDropdown", "fallbackInput"]
  }

  connect() {
    this.setFallback()
  }

  setFallback() {
    let fallback = this.attributesDropdownTarget.selectedOptions[0].dataset.default

    this.fallbackInputTarget.value = fallback || ""
  }
}
